// assets
import { IconDatabase, IconTable, IconServer, IconChartBar, IconSettings, IconKey } from '@tabler/icons-react';

// constant
const icons = { IconDatabase, IconTable, IconServer, IconChartBar, IconSettings, IconKey };

// ==============================|| CƠ SỞ DỮ LIỆU (Database) ||============================== //

const database = {
    id: 'database',
    title: 'Cơ sở dữ liệu',
    type: 'group',
    children: [
        {
            id: 'database-module',
            title: 'Database',
            type: 'collapse',
            icon: icons.IconDatabase,
            children: [
                {
                    id: 'database-dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/database/dashboard',
                    breadcrumbs: false
                },
                {
                    id: 'collections',
                    title: 'Collections',
                    type: 'item',
                    url: '/database/collections',
                    breadcrumbs: false
                },
                {
                    id: 'database-query',
                    title: 'Query Builder',
                    type: 'item',
                    url: '/database/query',
                    breadcrumbs: false
                },
                {
                    id: 'database-analytics',
                    title: 'Analytics',
                    type: 'item',
                    url: '/database/analytics',
                    breadcrumbs: false
                },
                {
                    id: 'database-connections',
                    title: 'Connections',
                    type: 'item',
                    url: '/database/connections',
                    breadcrumbs: false
                },
                {
                    id: 'database-settings',
                    title: 'Settings',
                    type: 'item',
                    url: '/database/settings',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default database;
